<template>
    <el-dialog :title="title" v-if="visible" :visible.sync="visible" width="85%" :close-on-click-modal="false" top="5vh"
    class="frame-dialog task-appoint-dialog" @close="close">
        <div class="task-appoint" v-loading="getListLoading">
            <div class="appoint-left">
                <div class="appoint-edit-info">
                    <batch-appoint-edit-cont ref="batchAppointEditInfo" :rowsData="rowsData" :selectChangeData="selectChangeData"
                    :selectChangeGroupData="selectChangeGroupData" :tableGroupData="tableData"
                    @checkResult="checkResult"></batch-appoint-edit-cont>
                </div>
            </div>
            <div class="appoint-right">
                <right-table
                    class="task-appoint-table"
                    :loading="getListLoading"
                    :contentTableData="tableData"
                    @selectChange="selectChange"
                >
                </right-table>
            </div>
        </div>
        <PercentLoading ref="percentLoading" :config="{ modal: true }"></PercentLoading>

        <div slot="footer" class="dialog-footer">
            <el-button @click="close">取 消</el-button>
            <el-button type="primary" @click="handleSave">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
import { batchAppointmentApi, getTransportAppointmentListApi } from '../../../../../api/appointmentCenter';
import BatchAppointEditCont from './BatchAppointEditCont';
import orderDataDict from '../../../../../utils/orderDataDict';
import config from './appointConfig';
import PercentLoading from './PercentLoading';
import { hideActionFunc } from './taskCenterFunc.js';
import RightTable from './RightTable';
import { filterSupportAlloc } from '../../util.js';

const { OFC, CAINIAO } = orderDataDict.SOURCE_SYSTEM;
export default {
    components: { RightTable, BatchAppointEditCont, PercentLoading },
    props: {
        title: String
    },
    data() {
        return {
            visible: false,
            rowsData: [],
            tableData: [],
            contentTableData: [],
            getListLoading: false,
            loadingVisible: false,
            appointTableColumns: config.batchAppointTable,
            appointInfo: {},
            selectChangeData: [],
            selectChangeGroupData: []
        };
    },
    computed: {
        hasCainiaoOrder() {
            return !!this.rowsData.find(item => item.sourceSystem === CAINIAO);
        }
    },
    methods: {
        selectChange (val) {
            this.selectChangeGroupData = [];
            this.selectChangeData = [];
            val.forEach(v => {
                this.selectChangeData.push(...v.responseList);
            });
            this.selectChangeGroupData = val;
        },
        close() {
            this.visible = false;
            this.tableData = [];
            this.rowsData = [];
            this.appointInfo = {};
            this.selectChangeData = [];
            this.$refs.batchAppointEditInfo.reset();
        },
        handleSave () {
            this.$refs.batchAppointEditInfo.checkSave(this.tableData);
        },
        show(data) {
            const list = filterSupportAlloc(data);
            if (list && list.length) {
                this.visible = true;
                this.rowsData = list;
                this.getTableList(list);
            }
        },
        getTableList (data) { // table数据
            const params = {
                taskNoList: data.map(i => i.taskNo),
                operateType: 'REVERSE' // 正向订单:FORWARD 逆向订单:REVERSE
            };
            this.getListLoading = true;
            getTransportAppointmentListApi(params).then(res => {
                if (res && +res.code === 0) {
                    if (res.errMsg) {
                        this.$message.error(res.errMsg);
                    }
                    this.tableData = res.data || [];
                    this.tableData.forEach(itm => {
                        itm.isJzpFlag = itm.isJzp === 'Y' ? '是' : '否';
                    });
                }
            }).finally(() => {
                this.getListLoading = false;
                if (this.hasCainiaoOrder) {
                    this.$emit('showTips');
                }
            });
        },
        showLoading() {
            this.loadingVisible = true;
            this.$refs.percentLoading.start(100, true);
        },
        closeLoading() {
            this.$refs.percentLoading.start();
        },
        checkResult(data) {
            if (!data) return;
            if (!this.selectChangeData.length) {
                return this.$message.warning('请先勾选订单');
            }
            const ofcReasonList = ['1412', '1414', '1420', '1421', '1422', '1503', '1504'];
            const ofcFilterList = [];

            if (ofcReasonList.includes(data.appointmentExceptionType)) {
                this.selectChangeData.forEach(item => {
                    if (item.sourceSystem === OFC) {
                        ofcFilterList.push(item.taskNo);
                    }
                });
                if (ofcFilterList.length) {
                    this.$message.warning(`失败的单号为：[${ofcFilterList.toString()}]，OFC订单改约选择了物流原因，预约失败，自动剔除`);
                    data.taskNoList = data.taskNoList.filter(t => !ofcFilterList.includes(t));
                }
                if (!data.taskNoList.length) return;
            }
            data.operateType = 'FORWARD'; // 正向订单:FORWARD 逆向订单:REVERSE
            this.showLoading();
            batchAppointmentApi(data).then(res => {
                if (res && +res.code === 0) {
                    if (res.errMsg) {
                        this.$message.error(res.errMsg);
                    } else {
                        this.$message.success('预约成功');
                    }
                    if (!ofcFilterList.length) {
                        this.visible = false;
                        this.$emit('success');
                    }
                }
            }).finally(() => {
                this.closeLoading();
                this.getListLoading = false;
            });
        }
    }
};
</script>
<style lang="less">
.max-zindex {
    z-index: 9999!important;
}
.task-appoint-dialog {
    .el-dialog__body {
        padding-top: 0;
        position: relative;
    }
}
.task-appoint {
    display: flex;
    .appoint-left {
        width: 30%;
        padding: 10px 10px 0 0;
        border-right: 1px solid #e6e6e6;
        .el-form-item__label {
            color: #999;
        }
        .el-form-item__content {
            color: #333;
        }
        .el-form-item__content, .el-form-item__label {
            line-height: 24px;
        }
        .base-info {
            border-bottom: 1px solid #e6e6e6;
            margin-bottom: 10px;
            padding-bottom: 5px;
            .el-form-item {
                margin-bottom: 0px;
            }
        }
        .refresh.el-button {
            padding: 0;
            .el-icon-refresh {
                font-size: 14px;
                font-weight: bold;
                color: #00bcbf;
            }
        }
    }
    .appoint-right {
        width: 68%;
        padding: 10px 0 0 10px;
    }
    .summarizing {
        margin-top: 5px;
        :first-child {
            margin-right: 25px;
        }
        i {
            color: #000;
            font-style: normal;
        }
    }
}
</style>
